const checkValidPassword = password => {
  const filter = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/;
  return filter.test(password || '');
};

export default checkValidPassword;
